/**
 * 3 タブ目「モーショングラフィックス」の設定 (尺・比率・効果音・終了時の状態。motion-graphics-mode-plan.md §5.3)。
 * 設定欄 (PromptModePanel → MotionGraphicsSettingsSection) と生成 (useVideoHandlers の
 * handleGenerateMotionFromPrompt) が同じ値を読むため store に持つ。永続化はしない (画面を開き直したら既定値)。
 * 仕上げ方 (ライト / スタンダード / ダメ出し) は features/motion/quality.ts (経路 'layered')。
 */
import { create } from 'zustand';
import { DEFAULT_MOTION_LAYERED_SETTINGS, closestMotionLayeredAspect, type MotionLayeredSettings } from './layeredPromptMode';

type LayeredSettingsState = {
  settings: MotionLayeredSettings;
  /** 比率をカンバスから自動で選んだ素材 id。同じ素材では再度上書きしない (利用者が変えた比率を保つ) */
  aspectAppliedMaterialId: string | null;
  setSettings: (next: MotionLayeredSettings) => void;
  /** レイヤー素材が選ばれた (素材 id が変わった) ときに、カンバスに最も近い比率を入れる (§5.3) */
  applyCanvasAspect: (materialId: string, canvas: { width: number; height: number }) => void;
  reset: () => void;
};

export const useMotionLayeredSettingsStore = create<LayeredSettingsState>()((set) => ({
  settings: DEFAULT_MOTION_LAYERED_SETTINGS,
  aspectAppliedMaterialId: null,
  setSettings: (next) => set({ settings: next }),
  applyCanvasAspect: (materialId, canvas) => set((s) => (
    s.aspectAppliedMaterialId === materialId
      ? s
      : {
        aspectAppliedMaterialId: materialId,
        settings: { ...s.settings, aspectRatio: closestMotionLayeredAspect(canvas.width, canvas.height) },
      }
  )),
  reset: () => set({ settings: DEFAULT_MOTION_LAYERED_SETTINGS, aspectAppliedMaterialId: null }),
}));
